import { useContext } from "react"
import * as PropTypes from "prop-types"
import { WhiteSection } from "components/styled/Grid"
import { SeoPageContext } from "../SeoPageContext"
import Offers from "./Offers"

export default function OffersWrapper({ page, show, section }) {
  const context = useContext(SeoPageContext)
  const contentCars = Array.isArray(section.content?.cars) ? section.content.cars : []
  const firstCar = contentCars[0]
  const featuredOffer = firstCar?.featuredOffer || firstCar?.featured_offer ? firstCar : null
  const cars = featuredOffer ? contentCars.slice(1) : contentCars

  if (cars.length > 0) {
    return (
      <WhiteSection>
        <Offers cars={cars} page={page} show={show} section={section} />
      </WhiteSection>
    )
  }

  const rawAlternativeCars = section.content?.alternative_cars || section.content?.alternativeCars
  let alternativeCars = Array.isArray(rawAlternativeCars) ? rawAlternativeCars : []

  if (alternativeCars.length === 0 && context?.seoData?.page_sections) {
    const otherSection = context.seoData.page_sections.find(
      s => s.section_type !== "offers" && Array.isArray(s.content?.cars) && s.content.cars.length > 0
    )
    if (otherSection?.content?.cars) {
      alternativeCars = [...otherSection.content.cars]
        .filter(c => c && (c.price || c.minimumPrice))
        .sort((a, b) => {
          const priceA = Number(a.minimumPrice || a.price || 0)
          const priceB = Number(b.minimumPrice || b.price || 0)
          return priceA - priceB
        })
        .slice(0, 6)
    }
  }

  const alternativeSection = {
    ...section,
    subtitle: "No hay ofertas en este rango de precios. Te mostramos nuestras alternativas más económicas disponibles:"
  }

  return (
    <WhiteSection>
      <Offers cars={alternativeCars} page={page} show={show} section={alternativeSection} />
    </WhiteSection>
  )
}

OffersWrapper.defaultProps = {
  show: { xs: 12, sm: 8, xl: 12 }
}

OffersWrapper.propTypes = {
  page: PropTypes.string.isRequired,
  show: PropTypes.object,
  section: PropTypes.object.isRequired
}
